module.exports = __webpack_public_path__ + "img/IMG-20180803-WA0021.0ee7e1f8.jpg";